import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "faq" }
const _hoisted_2 = { class: "faq__content" }
const _hoisted_3 = { class: "faq__inner" }
const _hoisted_4 = { class: "faq__list" }
const _hoisted_5 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("section", { class: "faq__hero" }, [
      _createElementVNode("div", { class: "faq__hero-overlay" }),
      _createElementVNode("div", { class: "faq__hero-content" }, [
        _createElementVNode("h1", null, "Questions fréquentes")
      ])
    ], -1 /* CACHED */)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.questions, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "faq__item"
            }, [
              _createElementVNode("button", {
                class: "faq__question",
                onClick: $event => ($setup.toggle(index))
              }, [
                _createElementVNode("span", null, _toDisplayString(item.q), 1 /* TEXT */),
                _createElementVNode("span", {
                  class: _normalizeClass(["faq__icon", { 'faq__icon--open': $setup.openIndex === index }])
                }, "+", 2 /* CLASS */)
              ], 8 /* PROPS */, _hoisted_5),
              _createElementVNode("div", {
                class: _normalizeClass(["faq__answer", { 'faq__answer--open': $setup.openIndex === index }])
              }, [
                _createElementVNode("p", null, _toDisplayString(item.a), 1 /* TEXT */)
              ], 2 /* CLASS */)
            ])
          }), 64 /* STABLE_FRAGMENT */))
        ])
      ])
    ])
  ]))
}